import Modal from './modal';
import ModalGateWebinarEbook from './gate-webinar-ebook/script';

export default {
	[Modal.selector]: Modal,
	[ModalGateWebinarEbook.selector]: ModalGateWebinarEbook
};
